import React, {Component} from 'react';
import MainStore from '../stores/MainStore.js';
import Checkout from './Checkout';
//import * as Cart from '../libraries/Cart.js';
//import './FloatingCheckout.css';


class CheckoutSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  };

  UNSAFE_componentWillMount = () =>{
    MainStore.addChangeListener(this._onModeChange);
  };

  UNSAFE_componentWillUnmount = () =>{
    MainStore.removeChangeListener(this._onModeChange);
  };

  _onModeChange = () =>{
    //this.money+=12;
    this.setState({random:Math.random()});
  };

  render() {
    //if( this.props.total<=0 ) return null;
    return (
      <div className="float-lg-right text-right">
        <div className="text-right">
          <span className="total mr-2"><h2>Subtotal: </h2></span>
          <span className="price" data-cart-subtotal data-ocu-subtotal><span className="currency">$</span><span>{(MainStore.total/100).toFixed(2).replace(/[.,]00$/, "")}</span></span>
        </div>
        <div className="text-right">
          <span className="you_save mr-2"><h2>You Saved</h2>: </span>
          <span className="compare_at">${(MainStore.saved/100).toFixed(2).replace(/[.,]00$/, "")}</span>
        </div>
        <div>
          <small>Taxes and shipping calculated at checkout</small>
        </div>
        <Checkout
          total={MainStore.total}
          className="my-3 w-100"
        />
      </div>
    )
  };
}
export default CheckoutSection;